export const FORM_ERR_MESSAGE = {
  REQUIRED: 'harus diisi',
  PWD_PATTERN: 'minimal 1 Huruf Kapital, 1 Huruf Kecil, 1 Angka, 1 Spesial Karakter, dan Tidak terdapat spasi'
}

export const ERR_MESSAGE_500 = "500 : Terjadi kesalahan. Mohon coba beberapa saat lagi"

export const Required = <span style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}> *</span>